document.addEventListener("DOMContentLoaded", function (event) {
    if (!LBSApp.DirectDebit) {
        LBSApp.DirectDebit = {};

        const texts = {
            defaultErrorMessage: 'Det gick inte att slutföra din begäran.',
            waitingForBankIdAutoStartToken: 'Försöker öppna mobilt BankID.',
            openBankIdApp: 'Försöker öppna mobilt BankID. Tryck på knappen om BankID appen inte öppnas automatiskt.',
            waitingForBankIdAuth: 'Skriv in din säkerhetskod i BankID- appen och välj Identifiera eller Skriv under.'
        }

        const state = {
            directDebitRequestType: 'Registration'
        }

        // element references
        const el = {
            form: {
                personalNumberInput: document.querySelector('#RecurringPaymentModel_PersonalIdentityNumber'),
                signature: document.getElementById('DirectDebit_SignatureInput'),
                bankAccount: document.getElementById('DirectDebit_BankAccount'),
                bankSelect: document.getElementById('dd-bank'),
                bankAccountSelect: document.getElementById('dd-bank-account'),
                billectaTermsCheckbox: document.querySelector('[data-ag-terms-input-el]'),
                manualBankAccountClearNr: document.getElementById('DirectDebit_ClearingNumber'),
                manualBankAccountNr: document.getElementById('DirectDebit_AccountNumber'),
                directDebitSessionId: document.getElementById('DirectDebitSessionId'),
                errors: {
                    bankSelect: document.getElementById('RecurringPaymentModel_SelectedBank_ErrorMessage'),
                    personalIdentityNumber: document.getElementById('RecurringPaymentModel_PersonalIdentityNumber_ErrorMessage'),

                    selectedBankAccount: document.getElementById('RecurringPaymentModel_SelectedBankAccount_ErrorMessage'),
                    terms: document.getElementById('RecurringPaymentModel_SignupBillectaChecked_ErrorMessage')
                }
            },
            bankId: {
                openBankIdButton: document.getElementById('open-bankid-button'),
                qrCodeContainer: document.querySelector('.qr-code-container'),
                qrCodeSpinner: document.querySelector('.qr-code-container .loading-spinner-wrapper'),
                qrCodeImage: document.getElementById('QrCode'),
                sameDeviceBankIdContainer: document.querySelector('.same-device-bankid-container'),
                sameDeviceBankIdText: document.getElementById('same-device-bankid-text'),
            },
            error: {
                personalNumberInputErrorMessage: document.querySelector('#RecurringPaymentModel_PersonalIdentityNumber_ErrorMessage'),
                directDebitErrorContainer: document.getElementById('direct-debit-error'),
                errorMessage: document.getElementById('direct-debit-error-message'),
            },
            buttons: {
                consentButton: document.getElementById('ConsentButton'),
                initializeBankAccountRetrievalBtn: document.getElementById('BankSelected'),
                errorButton: document.getElementById('direct-debit-error-button'),
            },
            paymentTerms: document.getElementById('CampaignSignup_Step2_SignUpPaymentChecked'),
            manualBankAccountContainer: document.getElementById('direct-debit-manual-bank-input'),
            directDebitContainer: document.getElementById('direct-debit-container'),
            steps: {
                1: document.getElementById('direct-debit-step-1'),
                3: document.getElementById('direct-debit-step-3'),
                bankId: document.getElementById('direct-debit-step-bankid')
            }
        }

        function initEventListeners() {
            el.buttons.consentButton.addEventListener('click', signDirectDebitConsent.onInitialiseSignButtonClick);
            el.buttons.initializeBankAccountRetrievalBtn.addEventListener('click', selectBankAccount.initializeBankAccountRetrieval);
            el.buttons.errorButton.addEventListener('click', directDebitErrorButtonClickHandler);
            el.form.bankSelect.addEventListener('change', selectBankAccount.onBankSelectChange);
            el.bankId.openBankIdButton.addEventListener('click', bankId.onOpenBankIdButtonClick);
            
            if (el.form.personalNumberInput) {
                LBSApp.Validations.personalNumberLiveFormatter(el.form.personalNumberInput, el.error.personalNumberInputErrorMessage);
            }

            LBSApp.Validations.addValidation(el.form.manualBankAccountClearNr, validations.clearNr);
            LBSApp.Validations.addValidation(el.form.manualBankAccountNr, validations.bankAccountNr);
            LBSApp.Validations.addRequiredValidation(el.form.bankSelect);
            LBSApp.Validations.addRequiredValidation(el.form.bankAccountSelect);
            LBSApp.Validations.addRequiredValidation(el.form.billectaTermsCheckbox);
            LBSApp.Validations.addRequiredValidation(el.form.manualBankAccountClearNr);
            LBSApp.Validations.addRequiredValidation(el.form.manualBankAccountNr);
        }

        var mobilebankIdHasBeenOpen = false;
        function init() { 
            if (!el.directDebitContainer) {
                return;
            }
            initEventListeners();           
            
            var sessionId = getDirectDebitSessionId();
            if (sessionId) {
                api.getDirectDebitState(sessionId).then(res => {
                    if (res) {
                        mobilebankIdHasBeenOpen = true;
                        if (res.state == 1) {
                            bankId.displayBankId();
                            selectBankAccount.getBankAccounts(res.id);
                        }
                        if (res.state == 2) {
                            signDirectDebitConsent.getSignature(res.id);
                            bankId.displayBankId();
                        }
                    }
                })
            }
        }

        const selectBankAccount = {
            validate: function validate(markAsDirty = false) {
                const hasSelectedBank = el.form.bankSelect.lbsValidate(markAsDirty);
                // campaign page doesn't have a input field for personal identity number for direct debit
                const isPersonalIdentityNumberValid = !el.form.personalNumberInput || el.form.personalNumberInput.lbsValidate(markAsDirty);
                return hasSelectedBank && isPersonalIdentityNumberValid;
            },

            bankHasBeenChoosen: function bankHasBeenChoosen() {
                return el.form.bankSelect.selectedIndex > 0;
                return false;
            },

            isManualSetBankAccount: function isManualSetBankAccount() {
                const selectedBankChoice = el.form.bankSelect.value;
                return selectedBankChoice === 'Custom';
            },

            isManualBankAccountIsValid: function isBankAccountIsValid(account) {
                var accountRegex = RegExp('^[0-9]*$');
                var match = accountRegex.exec(account);
                return match !== null;
            },

            isManualClearNrIsValid: function isManualClearNrIsValid(account) {
                var accountRegex = RegExp('^[0-9]{4,5}$');
                var match = accountRegex.exec(account);
                return match !== null;
            },

            getSelectedBankAccountNr: function () {
                if (selectBankAccount.isManualSetBankAccount()) {
                    return el.form.manualBankAccountClearNr.value + '-' + el.form.manualBankAccountNr.value;
                }
                else if (el.form.bankAccountSelect.value) {
                    return el.form.bankAccountSelect.value;
                }
                else return el.form.bankAccount.value;
            },

            onBankSelectChange: function onBankSelectChange(e) {
                if (e.target.value === 'Custom')
                    bankId.displayManualBankInput();
                else
                    bankId.hideManualBankInput();
                hideErrorMessage();
            },

            initializeBankAccountRetrieval: async function initializeBankAccountRetrieval() {
                if (!selectBankAccount.validate(true)) {
                    return;
                }

                setButtonLoadingStatus(el.buttons.initializeBankAccountRetrievalBtn, true);

                var bank = el.form.bankSelect.value;
                var socialSecurityNumber = getSocialSecurityNumber();

                mobilebankIdHasBeenOpen = false;

                try {
                    const formData = formDataState.getFormData();
                    var response = await api.initiateBankAccountRetrieval(
                        bank,
                        socialSecurityNumber,
                        isPhone(),
                        state.directDebitRequestType,
                        formData
                    );

                    if (response.isSuccess) {
                        bankId.displayBankId();
                        updateQueryString(response.data.id);
                        el.form.directDebitSessionId.value = response.data.id;
                        selectBankAccount.getBankAccounts(response.data.id);
                    } else {
                        if (response.errorCode === "INVALID_SSN") {
                            el.error.personalNumberInputErrorMessage.style.display = 'block';
                            displayStep1();
                        }
                        else {
                            showErrorMessage(response.message, false);
                        }
                    }
                }
                catch (err) {
                    console.error(err);
                    showErrorMessage(null, false);
                }
                finally {
                    setButtonLoadingStatus(el.buttons.initializeBankAccountRetrievalBtn, false);
                }
            },

            getBankAccounts: async function getBankAccounts(directDebitSessionId) {
                try {
                    var response = await api.getBankAccounts(directDebitSessionId, window.location.href);
                    if (response.isError) {
                        showErrorMessage(response.message);
                        return;
                    }
                    var data = response.data;
                    if (data.pollAgain) {
                        bankId.handleBankIdPoll(data);
                        setTimeout(function () { selectBankAccount.getBankAccounts(directDebitSessionId); }, 2000);
                    } else if (data.status === 'Failed' || data.status === 'Unknown' || data.status === 2) {
                        showErrorMessage(data.errorMessage);
                        bankId.hideBankId();
                    } else {
                        displayStep3(data);
                    }
                }
                catch (err) {
                    console.error(err);
                    showErrorMessage(null);
                    bankId.hideBankId();
                }
            },

            setBankAccountOptions: function setBankAccountOptions(accounts) {
                $("#dd-bank-account").empty();
                let defaultOption = document.createElement('option');
                defaultOption.text = "Var god välj konto";
                defaultOption.value = "";
                defaultOption.disabled = true;
                defaultOption.selected = true;
                el.form.bankAccountSelect.options.add(defaultOption);

                accounts.forEach(function (data) {
                    let option = document.createElement('option');
                    option.text = data.name + ' (' + data.number + ')';
                    option.value = data.number;
                    el.form.bankAccountSelect.options.add(option);
                });
            }
        }

        const signDirectDebitConsent = {
            validate: function validate(markAsDirty = false) {
                const hasSelectedBankAccount = el.form.bankAccountSelect.selectedIndex > 0;
                const hasCheckedTerms = el.form.billectaTermsCheckbox.checked;
                const isManualSetBankAccount = selectBankAccount.isManualSetBankAccount();
                const isManualSetBankAccountValid = selectBankAccount.isManualClearNrIsValid(el.form.manualBankAccountClearNr.value) && selectBankAccount.isManualBankAccountIsValid(el.form.manualBankAccountNr.value);

                const validBankAccount = isManualSetBankAccount ? isManualSetBankAccountValid : hasSelectedBankAccount;
                if (!isManualSetBankAccount) {
                    el.form.bankAccountSelect.lbsValidate(true);
                }
                else {
                    el.form.manualBankAccountClearNr.lbsValidate(true);
                    el.form.manualBankAccountNr.lbsValidate(true);
                }
                el.form.billectaTermsCheckbox.lbsValidate(true);

                return validBankAccount && hasCheckedTerms;
            },

            onInitialiseSignButtonClick: function onInitialiseSignButtonClick() {
                signDirectDebitConsent.initialiseSignRequest();
            },

            initialiseSignRequest: async function initialiseSignRequest() {
                if (!signDirectDebitConsent.validate(true)) {
                    return;
                }
                if (selectBankAccount.isManualSetBankAccount()) {
                    var bankAccount = selectBankAccount.getSelectedBankAccountNr();
                    el.buttons.consentButton.disabled = true;
                    var response = await api.isBankAccountValid(bankAccount);
                    el.buttons.consentButton.disabled = false;
                    if (response.isBankAccountValid) {
                        signDirectDebitConsent.startSignRequest();
                    } else {
                        showErrorMessage(response.errorMessage, false);
                    }
                } else {
                    signDirectDebitConsent.startSignRequest();
                }
            },

            startSignRequest: async function startSignRequest() {
                const directDebitSessionId = getDirectDebitSessionId();
                const bankAccountNr = selectBankAccount.getSelectedBankAccountNr();
                const personalIdentityNumber = getSocialSecurityNumber();
                const formData = formDataState.getFormData();
                setButtonLoadingStatus(el.buttons.consentButton, true);
                try {
                    var response = await api.initialiseSignRequest(directDebitSessionId, bankAccountNr, personalIdentityNumber, state.directDebitRequestType, formData);
                    if (response.isError) {
                        showErrorMessage(response.message);
                        return;
                    }
                    else {
                        updateQueryString(response.data.id);
                        el.form.directDebitSessionId.value = response.data.id;
                        signDirectDebitConsent.getSignature(response.data.id);
                        mobilebankIdHasBeenOpen = false;
                    }
                }
                catch (err) {
                    console.error(err);
                    showErrorMessage(null);
                    return;
                }
                finally {
                    setButtonLoadingStatus(el.buttons.consentButton, false);
                    hide(el.buttons.consentButton);
                }
                bankId.displayBankId();
            },

            getSignature: async function getSignature(directDebitSessionId) {
                try {
                    const response = await api.getSignature(directDebitSessionId, window.location.href);

                    const data = response.data;
                    if (data.pollAgain) {
                        bankId.handleBankIdPoll(data);
                        setTimeout(function () { signDirectDebitConsent.getSignature(directDebitSessionId); }, 2000);
                    } else {
                        var status = data.status;
                        if (!status || status.toLowerCase() == "error" || !data.signature) {
                            showErrorMessage(data.errorMessage);
                        }
                        else {
                            el.form.signature.value = data.signature;
                            if (el.form.personalNumberInput) {
                                el.form.personalNumberInput.value = data.personalIdentityNumber;
                            }
                            signDirectDebitConsent.submitSignature();
                        }
                    }
                }
                catch (err) {
                    console.error(err);
                    showErrorMessage(null);
                }
            },

            submitSignature: function submitSignature() {
                const paymentForm = document.getElementById("payment-form");
                el.form.bankAccount.value = selectBankAccount.getSelectedBankAccountNr();
                if (paymentForm) {
                    paymentForm.submit();
                }

                const registrationForm = document.getElementById("registration-form");
                if (registrationForm) {
                    registrationForm.submit();
                }
            }
        }

        const bankId = {

            handleBankIdPoll: function handleBankIdPoll(data) {
                if (isPhone()) {

                }
                else if (data.bankIdQRCode) {
                    bankId.showQrCode(data.bankIdQRCode);
                }
                else if (!data.bankIdQRCode) {
                    bankId.hideQrCode();
                }

                bankId.setAutoStartToken(data.bankIdAutoStartLink, isPhone());
            },
            setAutoStartToken: function (autoStartLink, tryToOpen) {
                el.bankId.openBankIdButton.href = autoStartLink;
                if (autoStartLink) {
                    el.bankId.sameDeviceBankIdText.innerText = texts.openBankIdApp;
                    if (mobilebankIdHasBeenOpen) {
                        el.bankId.sameDeviceBankIdText.innerText = texts.waitingForBankIdAuth;
                    }
                    else if (!mobilebankIdHasBeenOpen && tryToOpen) {
                        mobilebankIdHasBeenOpen = true;
                        window.location.replace(autoStartLink);
                    }
                    setTimeout(() => {
                        show(el.bankId.openBankIdButton);
                    }, 300)
                }
                else {
                    el.bankId.sameDeviceBankIdText.innerText = texts.waitingForBankIdAutoStartToken;
                    hide(el.bankId.openBankIdButton);
                }
            },
            onOpenBankIdButtonClick: function onOpenBankIdButtonClick() {
                mobilebankIdHasBeenOpen = true;
                el.bankId.sameDeviceBankIdText.innerText = texts.waitingForBankIdAuth;
            },

            showQrCode: function showQrCode(qrCode) {
                hide(el.bankId.qrCodeSpinner);
                el.bankId.qrCodeImage.setAttribute('src', qrCode);
                show(el.bankId.qrCodeImage);
                show(el.bankId.qrCodeContainer);
            },

            hideQrCode: function hideQrCode() {
                show(el.bankId.qrCodeSpinner);
                el.bankId.qrCodeImage.setAttribute('src', '');
                hide(el.bankId.qrCodeImage);
            },

            displayBankId: function displayBankId() {
                hideAllSteps();
                hidePaymentsListContainer();
                hideUserWarningMessageStep1("UserWarningMessageStep1");
                hideUserWarningMessageStep1("UserWarningMessageStep1BankId");
                hide(el.bankId.openBankIdButton);
                show(el.steps.bankId)
                if (isPhone()) {
                    hide(el.bankId.qrCodeContainer);
                    show(el.bankId.sameDeviceBankIdContainer);
                }
                else {
                    show(el.bankId.qrCodeContainer);
                    hide(el.bankId.sameDeviceBankIdContainer);
                }
            },

            hideBankId: function hideBankId() {
                hide(el.steps.bankId);
                $('#QrCode').hide();
            },

            displayManualBankInput: function displayManualBankInput() {
                hide(el.form.bankAccountSelect);
                hide(el.steps.bankId);
                hide(el.buttons.initializeBankAccountRetrievalBtn);
                show(el.manualBankAccountContainer);
                show(el.steps[3]);
                show(el.buttons.consentButton);
            },

            hideManualBankInput: function hideManualBankInput() {
                hide(el.manualBankAccountContainer);
                hide(el.steps.bankId);
                hide(el.steps[3]);
                hide(el.buttons.consentButton);
                show(el.form.bankAccountSelect);
                show(el.buttons.initializeBankAccountRetrievalBtn);
            }
        }

        const validations = {
            clearNr: function clearNr(evt) {
                const regex = /^[0-9]{4,5}$/;
                const isValid = regex.test(evt);
                return {
                    isValid: isValid,
                    errorMessage: 'Du måste ange ett giltigt clearnr på fyra eller fem siffror'
                }
            },

            bankAccountNr: function clearNr(evt) {
                const regex = /^[0-9]*$/;
                const isValid = regex.test(evt);
                return {
                    isValid: isValid,
                    errorMessage: 'Du måste ange ett giltigt kontonummer bestående av enbart siffror'
                }
            }
        }

        function directDebitErrorButtonClickHandler() {
            hideErrorMessage();
            displayStep1();
            if (selectBankAccount.isManualSetBankAccount()) {
                bankId.displayManualBankInput();
            }
            showPaymentsListContainer();
        }

        function getSocialSecurityNumber() {
            var socialSecurityNumberField = document.getElementById('CampaignSignup_Step1_PersonalIdentityNumber');
            var socialSecurityNumber = socialSecurityNumberField ? socialSecurityNumberField.value : '';
            if (socialSecurityNumber === '') { // depending on form
                socialSecurityNumberField = document.getElementById('RecurringPaymentModel_PersonalIdentityNumber');
                socialSecurityNumber = socialSecurityNumberField ? socialSecurityNumberField.value : '';
            }
            return socialSecurityNumber;
        }

        function isPhone() {
            return /Android|webOS|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }

        function updateQueryString(directDebitSessionId) {
            LBSApp.UrlHelpers.updateQueryStringParam('ag-id', directDebitSessionId);
        }

        function getDirectDebitSessionId(directDebitSessionId) {
            return LBSApp.UrlHelpers.getQueryStringParam('ag-id');
        }

        function hideUserWarningMessageStep1(id) {
            var userMessage = document.getElementById(id);
            if (userMessage) {
                userMessage.innerHTML = "";
            }

        }

        function showErrorMessage(message, showRetryButton = true) {
            bankId.hideBankId();
            if (el.error.directDebitErrorContainer) {
                el.error.errorMessage.innerHTML = message || texts.defaultErrorMessage;
                show(el.error.directDebitErrorContainer);
                if (showRetryButton) {
                    show(el.buttons.errorButton);
                }
                else {
                    hide(el.buttons.errorButton);
                }
                
            }
        }

        function hideErrorMessage() {
            hide(el.error.directDebitErrorContainer)
        }

        function showPaymentsListContainer() {
            if ($('#payments-list-container').length > 0) {
                $('#payments-list-container').show();
            }
        }

        function hidePaymentsListContainer() {
            if ($('#payments-list-container').length > 0) {
                $('#payments-list-container').hide();
            }
        }

        function displayStep1() {
            hideAllSteps();
            $('#direct-debit-step-1').show();
            $('#BankSelected').show();
        }

        function hideStep1() {
            $('#direct-debit-step-1').hide();
            $('#BankSelected').hide();
        }

        function hideStep3() {
            $('#direct-debit-step-3').hide();
        }
        function displayStep3(response) {
            hideAllSteps();
            $('#direct-debit-step-3').show();


            if ($('#ConsentHeader').length > 0) {
                $('#ConsentHeader').show();
            }
            showConsentButton();
            selectBankAccount.setBankAccountOptions(response.accounts);
            el.form.bankAccountSelect.focus();
        }

        function hide(el) {
            if (el) {
                el.style.display = 'none';
            }
        }

        function show(el, type = 'block') {
            if (el) {
                el.style.display = type;
            }
        }

        function setButtonLoadingStatus(buttonEl, isLoading) {
            if (isLoading) {
                buttonEl.setAttribute('disabled', '');
                buttonEl.classList.add('is-loading');
            }
            else {
                buttonEl.removeAttribute('disabled');
                buttonEl.classList.remove('is-loading');
            }
        }

        function hideAllSteps() {
            hideStep1();
            bankId.hideBankId();
            hideStep3();
        }
       
        function showConsentButton() {
            if ($('#ConsentButton').length > 0) {
                $('#ConsentButton').show();
            }
        }

        const formDataState = {
            formDataFns: [],
            registerFormDataDelegate: function registerFormDataDelegate(fn) {
                formDataState.formDataFns.push(fn)
            },
            getFormData: function getFormData() {
                const formData = formDataState.formDataFns.map(x => x());
                return formData;
            }
        }

        function setDirectDebitRequestType(directDebitRequestType) {
            state.directDebitRequestType = directDebitRequestType;
        }

        LBSApp.DirectDebit.RegisterFormDataDelegate = formDataState.registerFormDataDelegate;
        LBSApp.DirectDebit.SetDirectDebitRequestType = setDirectDebitRequestType;

        const api = LBSApp.DirectDebit.Api = {
            getDirectDebitState: async function (id) {
                var response = await fetch(`/umbraco/api/billecta/GetDirectDebitState?id=${id}`);
                var data = await response.text();
                if (!data) {
                    return null;
                }
                return JSON.parse(data);
            },
            initiateBankAccountRetrieval: async function (
                bank,
                personalIdentityNumber,
                isPhone,
                directDebitRequestType,
                formData
            ) {
                var response = await fetch('/umbraco/api/billecta/InitiateBankAccountRetrieval', {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    },
                    body: JSON.stringify({
                        bank: bank,
                        personalIdentityNumber: personalIdentityNumber,
                        isPhone: isPhone,
                        formData: formData,
                        directDebitRequestType: directDebitRequestType
                    })
                })
                return await response.json();
            },
            getBankAccounts: async function (id, bankIdRedirectUrl) {
                var response = await fetch(`/umbraco/api/billecta/GetBankAccounts?id=${id}&bankIdRedirectUrl=${encodeURIComponent(bankIdRedirectUrl)}`, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                });
                return await response.json();
            },
            initialiseSignRequest: async function (id, bankAccountNr, personalIdentityNumber, directDebitRequestType, formData) {
                var response = await fetch('/umbraco/api/billecta/InitialiseSignRequest?id=' + (id || ''), {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    },
                    body: JSON.stringify({
                        bankAccountNr: bankAccountNr,
                        directDebitRequestType: directDebitRequestType,
                        personalIdentityNumber: personalIdentityNumber,
                        formData: formData
                    })
                });
                return await response.json();
            },
            getSignature: async function (id, bankIdRedirectUrl) {
                var response = await fetch(`/umbraco/api/billecta/getSignature?id=${id}&bankIdRedirectUrl=${encodeURIComponent(bankIdRedirectUrl)}`, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                })
                var data = await response.json();
                return data;
            },
            isBankAccountValid: async function (bankAccountNr) {
                var response = await fetch(`/umbraco/api/billecta/IsBankAccountValid`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    },
                    body: JSON.stringify({
                        bankAccountNr: bankAccountNr
                    })
                });
                var data = await response.json();
                return data;
            },
        }

        init();
    }
});
